const eventName = "DOMContentUpdated";

export default class DOMUpdateEvent {

    constructor(options={}) {
        this.fireOnDOMContentLoaded = options.hasOwnProperty('fireOnDOMContentLoaded') ? options['fireOnDOMContentLoaded'] : true;

        if (this.fireOnDOMContentLoaded == true) {
            document.addEventListener("DOMContentLoaded", this.fire); // Fire the update event when the DOM loads.
        };
    }

    listen(callback) {
        return document.addEventListener(eventName, callback);
    }

    unlisten(callback) {
        return document.removeEventListener(eventName, callback);
    }

    fire() {
        document.dispatchEvent( new Event(eventName) );
    }

}